export const menuItems = [
    {
        label: "Home",
        icon: "mdi mdi-apps",
        link: "/"
    },
    {
        label: "Apply Now",
        icon: "mdi mdi-pen",
        link: "/applynow"
    },
    {
        label: "Admission History",
        icon: "bx-clipboard",
        link: "/admissions"
    },
    {
        label: "My Profile",
        icon: "bx-user",
        link: "/myprofile"
    },
    {
        label: "Change Password",
        icon: "bx-lock",
        link: "/changepassword"
    },    
];